import { useMutation } from '@tanstack/react-query';
import { useNavigate } from 'react-router-dom';
import useAuthStore from '@store/useAuthStore';
import { loginApi, logoutApi } from '@/api/userApi';
import feedback from '@/components/ui/general/feedback/feedback';

export default function useAuth() {
  const navigate = useNavigate();

  // 1. Get the actions directly from the store.
  const { setAuthState, clearAuthState } = useAuthStore.getState();
  
  // 2. Subscribe to the user data for UI components.
  const user = useAuthStore((state) => state.user);

  // 3. The login mutation now simply calls `setAuthState` on success.
  const loginMutation = useMutation({
    mutationFn: (credentials) => loginApi(credentials.email, credentials.password),
    onSuccess: (response) => {
      // The `persist` middleware will automatically save this to localStorage.
      setAuthState(response.data);
    },
  });

  const logoutMutation = useMutation({
    mutationFn: logoutApi,
    onSuccess: () => {
      // The `persist` middleware will automatically clear localStorage.
      clearAuthState();
      feedback.success('👋 ¡Hasta luego!');
    },
  });

  return {
    user,
    isLoadingUser: loginMutation.isPending || logoutMutation.isPending,
    login: (credentials) => {
      loginMutation.mutate(credentials, {
        onSuccess: () => navigate('/dashboard'),
      });
    },
    isLoggingIn: loginMutation.isPending,
    loginError: loginMutation.error,
    logout: () => {
      logoutMutation.mutate(undefined, {
        onSuccess: () => navigate('/'),
      });
    },
    isLoggingOut: logoutMutation.isPending,
  };
}